module.exports = __webpack_public_path__ + "img/cal-implant.d969fce2.png";